//changes for HIMSTAT 2026/27
export const dpi = [
    {
        name: 'Josua Edward Budianto',
        position: 'President'
    },
    {
        name: 'Dewi Chaireia',
        position: 'Treasurer'
    },
    {
        name: 'Vanda Bethania Davida',
        position: 'Secretary'
    },
]

export const lrd = [
    {
        name: 'Cornelius Christian Setiadi',
        position: 'LRD Director'
    },
    {
        name: 'Nicholas Vincent Effendi',
        position: 'Head of HRDC'
    },
    {
        name: 'Karina Widyawati',
        position: 'Head of ET'
    },

        {
        name: 'Darell Jevin Stanley',
        position: 'Head of WebDev'
    },
]

export const hrdc = [
    {
        name: 'Nicholas Vincent Effendi',
        position: 'Head of HRDC'
    },
    {
        name: 'Amelia Airin',
        position: 'HRDC Staff'
    },
    {
        name: 'Chariel Caniago',
        position: 'HRDC Staff'
    },
    {
        name: 'Duta Bahari Putra',
        position: 'HRDC Staff'
    },
    {
        name: 'Theodore Wiryo Pranoto',
        position: 'HRDC Staff'
    },
]

export const et = [
    {
        name: 'Karina Widyawati',
        position: 'Head of ET'
    },
    {
        name: 'Bimo Tsaqif Prathama',
        position: 'ET Staff'
    },
    {
        name: 'Dinda Amelya Putri',
        position: 'ET Staff'
    },
    {
        name: 'Kentaro Adrian Kurniawan',
        position: 'ET Staff'
    },
    {
        name: 'Muhamad Rangga Fauzan Aditya',
        position: 'ET Staff'
    },
]

export const web = [
    {
        name: 'Darell Jevin Stanley',
        position: 'Head of WebDev (Project Manager and Front End Developer)'
    },
    {
        name: 'Andy Yang',
        position: 'WebDev Staff (Front End Developer)'
    },
    {
        name: 'Steven Aten',
        position: 'WebDev Staff (Back End Developer)'
    },
]

export const mic = [
    {
        name: 'Mohammad Aditya Rangga Risky Pasolang',
        position: 'MIC Director'
    },
    {
        name: 'Aretha Sachio Christabel',
        position: 'Head of VCD'
    },
    {
        name: 'Christopher Amadeus Djingga',
        position: 'Head of PR'
    },
]

export const vcd = [
    {
        name: 'Aretha Sachio Christabel',
        position: 'Head of VCD'
    },
    {
        name: 'Idlandanu Raafi Zalrian',
        position: 'VCD Staff'
    },
    {
        name: 'Kelvin Saputra',
        position: 'VCD Staff'
    },
    {
        name: 'Liesella Indriasari Panjaitan',
        position: 'VCD Staff'
    },
]

export const pr = [
    {
        name: 'Christopher Amadeus Djingga',
        position: 'Head of PR'
    },
    {
        name: 'Kayla Farrensia',
        position: 'PR Staff'
    },
    {
        name: 'Jonathan',
        position: 'PR Staff'
    },
    {
        name: 'Jose Alfredo Nababan',
        position: 'PR Staff'
    },
]

